/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { EventsTableRowFragment, EventsTableSectionFragment } from "@cosmos/hygraph-schema";

import {
	BlurredImage,
	ResponsiveContainer,
	SectionContainer,
	SectionHeading,
	BackgroundContainer,
} from "@components/elements";

import { EventsTable } from "./EventsTable.organism";
import { VStack } from "@panda/jsx";
import { css } from "@panda/css";

const glowWrap = css({
	position: "absolute",
	height: "400px",
	transform: "translateX(-25%) translateY(92px)",
	w: "65%",
	zIndex: 0,
	xxlDown: {
		w: "75%",
	},
	xlDown: {
		w: "85%",
	},
});

export const EventsTableSection = (props: EventsTableSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(props?.config?.heading?.title || props?.config?.heading?.desc);
	const validContent = Boolean(props.events.some((event: EventsTableRowFragment) => !!event.title || !!event.location));
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer
			bgAnimation={props?.config?.backgroundAnimation}
			bgImageAsset={props?.config?.backgroundImage}
			bgFullHeight={props?.config?.backgroundFullHeight}
			edsBackgroundColor={props?.config?.edsBackgroundColor}
		>
			<div className={glowWrap}>
				<BlurredImage
					image={{ id: props?.blurredImage?.id || "", url: props?.blurredImage?.url || "" }}
					blurPixels={100}
					opacity={0.3}
					width={400}
					height={400}
				/>
			</div>
			<ResponsiveContainer>
				<SectionContainer>
					<VStack alignItems="stretch" gap="eds.dimension.56" className="events-table-section">
						{validHeading ? <SectionHeading {...props?.config?.heading} /> : null}
						{validContent ? <EventsTable {...props} /> : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
